import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import FormHeader from "@/components/ui/organisms/MHeader";
import MSpacer from "@/components/ui/atoms/MSpacer";
import MFrame from "@/components/ui/atoms/MFrame";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import styles from "../settings.module.css";
import { MButton } from "@/components/ui/atoms/MButtons";

const ConsentWithdrawal: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const memberInfo = useSelector(
    (state: RootState) => state.auth?.member || {}
  );
  const [isConfirming, setIsConfirming] = useState(false);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      // TODO: Call API to withdraw consent
      // await consentService.withdrawConsent();
      // Then redirect to login or home
      navigate("/profile/family/delete-member");
    } catch (error) {
      console.error("Failed to withdraw consent:", error);
      setIsConfirming(false);
    }
  };

  const getDescription = () => {
    return (
      <span>
        {t("privacy.consentWithdrawalDescription")}{" "}
        <a href="mailto:support@maatra.health" target="_blank" className={styles.emailLink}>
          support@maatra.health
        </a>
      </span>
    );
  };

  return (
    <div className="profile-page-root">
      <FormHeader
        module="consent-withdrawal"
        memberInfo={memberInfo}
        description={getDescription()}
      />
      <MSpacer mt={24} />
      <div className="">
        {/* Warning Card */}
        <MFrame className={styles.consentInfoContainer}>
          <div className={styles.consentInfoTitleContainer}>
            <IconAlertTriangle
              size={24}
              className="text-[var(--brand-primary-indigo-700)]"
            />
            <h3 className={`body-base-semibold ${styles.consentInfoTitle}`}>
              {t("privacy.consentWithdrawalWarning")}
            </h3>
          </div>
          <div className="flex-1">
            <p className={`body-xs-medium ${styles.consentInfoDetails}`}>
              {t("privacy.consentWithdrawalDetails")}
            </p>
          </div>
        </MFrame>

        {/* Action Buttons */}
        <div className="confirm-footer">
          <MButton
            text={t("common.cancel")}
            variant="outline"
            size="lg"
            onClick={handleCancel}
            disabled={isConfirming}
            className="w-1/2"
          />
          <MButton
            text={isConfirming ? "Processing..." : t("common.confirm")}
            size="lg"
            onClick={handleConfirm}
            disabled={isConfirming}
            className="w-1/2"
          />
        </div>
      </div>
    </div>
  );
};

export default ConsentWithdrawal;
